import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { Block } from 'shared/components/Block';
import { SubTitle } from 'shared/components/SubTitle';
import { Description } from 'shared/components/Description';
import { ThreeUtpBlock } from 'shared/components/ThreeUtpBlock';
import { UTP } from './constants';
import { DetailsBtnLink } from 'shared/components/DetailsBtnLink';
import { ONLINE_CONTRACT } from 'shared/constants/links';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const OnlineContract: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <Element name={ENavigation.OnlineContract}>
          <Block>
            <SubTitle text="Онлайн-договор" />
            <Description
              text={[
                {
                  value:
                    'Сервис для аренды жилья, разработанный совместно с Минцифры. Он позволяет заключать договоры онлайн с юридической силой и оформлять временную регистрацию через Госуслуги.',
                },
              ]}
            />
            <Description text={[{ value: 'Что это даёт участникам:' }]} />
            <ThreeUtpBlock elements={UTP} />
            <DetailsBtnLink link={ONLINE_CONTRACT} withOutMargin />
          </Block>
        </Element>
      </Wrapper>
    </div>
  );
};
